import React, { Component } from 'react';

import Collapse from '../../../../../../../../hoc/Collapse/Collapse';
import { jsDictionaryEquals } from '../../../../../../../../ressources/functionJS/jsDictionaryEquals';
import styles from './VueRapport.module.scss';

class VueRapport extends Component {
  constructor(props) {
    super(props);
    this.state = { ...(props.preconfigureObjet || {}) };
  }

  // Update state from props if needed
  updateStateFromProps = () => {
    const { preconfigureObjet } = this.props;
    if (preconfigureObjet) {
      this.setState({ ...preconfigureObjet });
    }
  };

  // Handle input changes
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  // Handle view ID changes
  handleViewIdChange = (view_id) => {
    this.setState({ view_id: parseInt(view_id, 10) });
  };

  componentDidMount() {
    this.updateStateFromProps();
  }

  componentDidUpdate(prevProps, prevState) {
    // Extract props for clarity
    const { preconfigureObjet, gererJson } = this.props;

    // Check if preconfigureObjet has changed
    if (
      this.hasPreconfigureObjectChanged(
        prevProps.preconfigureObjet,
        preconfigureObjet
      )
    ) {
      this.updateStateFromProps();
    }

    // Notify parent of state changes
    if (!jsDictionaryEquals(prevState, this.state) && gererJson) {
      gererJson(this.state);
    }
  }

  // Helper method to check if preconfigureObjet has changed
  hasPreconfigureObjectChanged = (previous, current) => {
    return previous !== current && !jsDictionaryEquals(previous, current);
  };

  render() {
    const { children, affichageProfil } = this.props;
    const { text } = this.state;

    return (
      <Collapse
        expandText={
          <div className={styles.contenuEnTete}>
            {this.props.contenuEnTete}
            <span className={styles.titre}>{this.state.text}</span>
            <span className={styles.bold}>
              {' '}
              ID du vue : {this.props.preconfigureObjet.view_id}{' '}
            </span>
          </div>
        }
      >
        {children}
        {this.renderInputField(text, affichageProfil)}
      </Collapse>
    );
  }

  // Render the expand text content
  renderExpandText = (contenuEnTete, text) => (
    <div className={styles.contenuEnTete}>
      {contenuEnTete}
      <span className={styles.titre}>{text}</span>
    </div>
  );

  // Render the input field
  renderInputField = (text, affichageProfil) => (
    <input
      className={styles.Input}
      type="text"
      name="text"
      value={text}
      disabled={affichageProfil === true}
      onChange={this.handleInputChange}
    />
  );
}

export default VueRapport;
